export default {
	created() {
		this.lastScrollY = null;
		this.onScroll = event => {
			if (this.lastScrollY !== null && typeof (this.handleWindowScroll) === 'function') {
				this.handleWindowScroll(window.scrollY - this.lastScrollY);
			}
			this.lastScrollY = window.scrollY;
		};
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},
};
